module.exports = __webpack_public_path__ + "static/media/Societe-Expertise-Immobilier-Vaud.cfc21f49.jpg";